import React from "react";
import { useTranslation } from "react-i18next";
import { Col, Container, Row } from "reactstrap";
import { Link } from "react-router-dom";
import UnapprovedPackageDashboardTable from "./pack/approvalPack";
import UninvoicedPackageDashboardTable from "./pack/uninvoiced";
import { useAppSelector } from "src/store";

const Dashboard = () => {
  const { t } = useTranslation();
  document.title = t("Dashboard.MetaTag");
  const user = useAppSelector((s) => s.auth.user);
  const name = user?.Name ? `, ${user.Name}` : "";

  const quick = [
    { to: "/clients", i: "mdi-account-group-outline", l: t("Menu.Clients"), c: "var(--m-accent)", b: "var(--m-accent-soft)" },
    { to: "/web/packages", i: "mdi-package-variant-closed", l: t("Menu.Packages"), c: "var(--m-warning)", b: "var(--m-warning-soft)" },
    { to: "/ticket/all", i: "mdi-lifebuoy", l: t("Menu.Ticket"), c: "var(--m-info)", b: "var(--m-info-soft)" },
    { to: "/subscriptions", i: "mdi-email-newsletter", l: t("Menu.Subscriptions"), c: "var(--m-success)", b: "var(--m-success-soft)" },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="m-page-header">
            <div>
              <h4 className="m-page-header__title">
                {t("Dashboard.Welcome")}
                {name} 👋
              </h4>
              <p className="m-page-header__sub">{t("Dashboard.WelcomeSub")}</p>
            </div>
          </div>

          <div className="m-quick">
            {quick.map((q) => (
              <Link to={q.to} className="m-quick__card" key={q.to}>
                <span className="m-quick__ic" style={{ background: q.b, color: q.c }}>
                  <i className={"mdi " + q.i} />
                </span>
                <span className="m-quick__t">{q.l}</span>
                <i className="mdi mdi-arrow-right m-quick__arrow" />
              </Link>
            ))}
          </div>

          <Row>
            <Col md={6}>
              <UnapprovedPackageDashboardTable />
            </Col>
            <Col md={6}>
              <UninvoicedPackageDashboardTable />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
